import { Text, View } from "@react-pdf/renderer";
import { type FunctionComponent } from "react";
import { type IntlShape } from "react-intl";

import { styles } from "./TableHeader.styles";

interface TableHeaderProps {
    hasArticleInfos: boolean;
    intl: IntlShape;
}

const TableHeader: FunctionComponent<TableHeaderProps> = ({ hasArticleInfos, intl }) => {
    return (
        <View style={styles.root}>
            <View style={styles.articleColumnContainer}>
                <Text>
                    {intl.formatMessage({ id: "sparePartsFinder.wishlist.pdf.tableHeader.article", defaultMessage: "Article" }).toUpperCase()}
                </Text>
            </View>

            <View style={styles.articleNrColumnContainer}>
                <Text>
                    {intl
                        .formatMessage({ id: "sparePartsFinder.wishlist.pdf.tableHeader.articleNumber", defaultMessage: "Article No." })
                        .toUpperCase()}
                </Text>
            </View>

            <View style={styles.modelColumnContainer}>
                <Text>{intl.formatMessage({ id: "sparePartsFinder.wishlist.pdf.tableHeader.model", defaultMessage: "Model" }).toUpperCase()}</Text>
            </View>

            {hasArticleInfos && (
                <>
                    <View style={styles.availabilityColumnContainer}>
                        <Text>
                            {intl
                                .formatMessage({
                                    id: "sparePartsFinder.wishlist.pdf.tableHeader.availability",
                                    defaultMessage: "Availability",
                                })
                                .toUpperCase()}
                        </Text>
                    </View>

                    <View style={styles.priceColumnContainer}>
                        <Text>
                            {intl.formatMessage({ id: "sparePartsFinder.wishlist.pdf.tableHeader.price", defaultMessage: "Price" }).toUpperCase()} *
                        </Text>
                    </View>

                    <View style={styles.quantityColumnContainer}>
                        <Text>
                            {intl.formatMessage({ id: "sparePartsFinder.wishlist.pdf.tableHeader.quantity", defaultMessage: "Qty" }).toUpperCase()} **
                        </Text>
                    </View>
                </>
            )}
        </View>
    );
};

export { TableHeader };
